export function validate(el: Element, scrollToError: boolean = true) {
  const hasError = el.getElementsByClassName('input-error')

  for (let i = 0; i < hasError.length; i += 1) {
    hasError[i]?.dispatchEvent(new Event('blur'))
  }

  if (scrollToError && hasError.length > 0) {
    hasError[0]?.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' })
  }

  return hasError.length === 0
}

export function reset(el: Element) {
  const touched = Array.from(el.getElementsByClassName('input-touched'))

  const active = document.activeElement as HTMLElement
  if (active) {
    active.blur()
  }

  setTimeout(() => {
    touched.forEach(element => {
      element.classList.remove('input-touched')
      element.dispatchEvent(new Event('reset'))
    })
  })
}
